import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { toRefs } from 'vue';

interface ButtonProps {
  title: string;
  onBtnClick: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MyBtn',
  props: {
    title: {},
    onBtnClick: { type: Function }
  },
  setup(__props: any) {

const props = __props;


const { title, onBtnClick } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onBtnClick) && _unref(onBtnClick)(...args))),
    class: "btn"
  }, _toDisplayString(_unref(title)), 1))
}
}

})